module.exports = __webpack_public_path__ + "media/native-apps/grona-kilar-d0b4a184.webp";